export default {
  name: 'organisations/pressure',
}
